import {IsString} from 'class-validator';

export class XmaTextEmojifyDto {
  @IsString()
  text!: string;
}
